export const capitalizeFirstLetter = (str = '') => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const toProperCase = (variableName) => {
  const parts = variableName.split(/[-_ ]|(?=[A-Z])/).filter(Boolean); // Split by common delimiters and camelCase
  const properName = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');
  return properName;
}
